import React from 'react';
import { func } from 'prop-types';
import Reaptcha from 'reaptcha';
import endPoints from '../../config/endPoints';

function RecaptchaWrapper(props) {
  const { onRecaptchaValidation } = props;
  return (
    <Reaptcha
      sitekey={endPoints.CAPTCHA_KEY}
      inject
      onVerify={onRecaptchaValidation}
    />
  );
}

RecaptchaWrapper.propTypes = {
  onRecaptchaValidation: func.isRequired,
};

export default RecaptchaWrapper;



// WEBPACK FOOTER //
// client/components/Recaptcha/index.js